<script lang="ts">
  export let svgClass: string;
  export let color: string = 'stroke-warning-300';
</script>

<svg class={svgClass} {color} xmlns="http://www.w3.org/2000/svg" width="40" height="40"
  ><g clip-path="url(#a)"
    ><path
      d="M19.077 3.22c.341-.821 1.505-.821 1.846 0l4.133 9.935a1 1 0 0 0 .843.613l10.725.86c.887.07 1.247 1.177.571 1.756l-8.172 7a1 1 0 0 0-.322.991l2.497 10.467c.206.865-.735 1.549-1.494 1.085l-9.183-5.609a1 1 0 0 0-1.042 0l-9.183 5.61c-.759.463-1.7-.221-1.494-1.086L11.3 24.375a1 1 0 0 0-.322-.991l-8.172-7c-.676-.579-.316-1.685.57-1.757l10.726-.86a1 1 0 0 0 .843-.612l4.133-9.935Z"
      fill="#FEC84B"
      style="fill:color(display-p3 .9965 .7856 .2937);fill-opacity:1"
    /></g
  ><defs
    ><clipPath id="a"
      ><path fill="#fff" style="fill:#fff;fill-opacity:1" d="M0 0h40v40H0z" /></clipPath
    ></defs
  ></svg
>
